import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { FlexRow } from 'ui-components/components/flex';

import { BulkApplyCheckbox } from '../../../../../../../fulfillment-plans/bulk-apply/bulk-apply-checkbox';
import { useEditRecipientTaxIdentifiersFormContext } from './context';
import messages from './messages';
import style from './styles.module.less';

/**
 * @param {object} props
 * @param {() => void} props.onClose - callback to execute logic when clicking on cancel or when data is saved
 * @returns {JSX.Element} - The render EditRecipientTaxIdentifiersFooter
 */
export const EditRecipientTaxIdentifiersFooter = ({ onClose }) => {
  const { saveTaxIdentifier, isBulkUpdate, applyToAllFulfillmentPlans, saveDisabled } = useEditRecipientTaxIdentifiersFormContext();

  const save = useCallback(async () => {
    const didSucceed = await saveTaxIdentifier();
    if (didSucceed) {
      onClose();
    }
  }, [onClose, saveTaxIdentifier]);

  return (
    <ModalFooter className={style.footer}>
      <FlexRow className={style['footer-buttons']}>
        <BulkApplyCheckbox
          isBulkUpdate={isBulkUpdate}
          message={messages.bulkUpdateAllShipments}
          toggleBulkUpdate={applyToAllFulfillmentPlans}
        />
        <div className={style['footer-right-side']}>
          <ModalFooterCancelButton />
          <Button disabled={saveDisabled} onClick={save} theme='primary'>
            <FormattedMessage {...messages.editRecipientTaxIdentifierSaveButton} />
          </Button>
        </div>
      </FlexRow>
    </ModalFooter>
  );
};
